import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Avatar, AvatarGroup, Button, Checkbox, Chip, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Modal, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Menu, MenuItem, TextField, Tooltip } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, useParams } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import moment from 'moment';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';
import TuneIcon from '@mui/icons-material/Tune';
import Filters2 from 'elements/Filters/Filters2';
import FiltersApplied2 from 'elements/Filters/FiltersApplied2';
import { TbFileExport } from "react-icons/tb";
import ExportClientsDialog from 'elements/ExportClientsDialog/ExportClientsDialog';
import { RiDeleteBin6Line } from "react-icons/ri";
import { PiDotsThreeOutlineFill, PiPencilLight, PiXCircleLight, PiCameraLight, PiEnvelopeSimpleLight } from "react-icons/pi";
import OrdersEditor from './OrdersEditor';
import { ApiRequest } from 'GlobalFunctions';
import { useSocketEvent } from 'SocketContext';
import StockValidatorDialog, { StockValidatorProduct } from './Components/StockValidatorDialog';
import BatchInvoiceProgressDialog from './Components/BatchInvoiceProgressDialog';
import BatchCard from './Components/BatchCard';
import BatchDetailDialog from './Components/BatchDetailDialog';

export default function OrdersList(props: any) {

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const {setLoading} = props;

  useEffect(() => {
    setLoading(false);
  }, [])
  
  const [list, setList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);

  const [page, setPage] = useState(1);
  const [filtersValues, setFiltersValues] = useState<any>([]);
  const [open, setOpen] = useState(false);

  const [openEditor, setOpenEditor] = useState(false);
  const [restrictions, setRestrictions] = useState<any>(null);
  const [advancedOrderEditor, setAdvancedOrderEditor] = useState(false);
  const [undeliveredView, setUndeliveredView] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const openMenu = Boolean(anchorEl);

  // Multi-select state
  const [selectedOrderIds, setSelectedOrderIds] = useState<Set<number>>(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [deselectedWhenAll, setDeselectedWhenAll] = useState<Set<number>>(new Set());
  const [totalItems, setTotalItems] = useState(0);

  const selectedCount = selectAll
    ? totalItems - deselectedWhenAll.size
    : selectedOrderIds.size;
  const isHeaderChecked = selectAll && deselectedWhenAll.size === 0;
  const isHeaderIndeterminate =
    (selectAll && deselectedWhenAll.size > 0) ||
    (!selectAll && selectedOrderIds.size > 0);
  const isRowSelected = (orderId: number) =>
    selectAll ? !deselectedWhenAll.has(orderId) : selectedOrderIds.has(orderId);

  const handleSelectAll = () => {
    if (isHeaderChecked || isHeaderIndeterminate) {
      setSelectAll(false);
      setSelectedOrderIds(new Set());
      setDeselectedWhenAll(new Set());
    } else {
      setSelectAll(true);
      setSelectedOrderIds(new Set());
      setDeselectedWhenAll(new Set());
    }
  };

  const handleRowSelect = (orderId: number) => {
    if (selectAll) {
      setDeselectedWhenAll((prev) => {
        const next = new Set(prev);
        if (next.has(orderId)) next.delete(orderId);
        else next.add(orderId);
        return next;
      });
    } else {
      setSelectedOrderIds((prev) => {
        const next = new Set(prev);
        if (next.has(orderId)) next.delete(orderId);
        else next.add(orderId);
        return next;
      });
    }
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, orderId: number, item: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrderId(orderId);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedOrderId(null);
    setSelectedItem(null);
  };

  const handleOrderSummary = () => {
    console.log("Resumen de pedido");
  };

  useEffect(() => {
    setSelectAll(false);
    setSelectedOrderIds(new Set());
    setDeselectedWhenAll(new Set());
  }, [filtersValues]);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page, filtersValues])

  // Actualizar lista en tiempo real via Socket.IO
  useSocketEvent('orders_updated', () => loadList());

  /*=========================================================
  LOAD LIST
  =========================================================*/
  const loadList = async () => {

    await ApiRequest({
      url: "/orders/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        page: page,
        filters: filtersValues,
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setTotalItems(response.total_items || 0);
        setLoading(false);
      },
    });
    
    // localStorage.setItem('page', page.toString())
}


  const gerRestrictions = async () => {
    await ApiRequest({
      url: "/companies/restrictions",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      setResponse: (response: any) => {
        setRestrictions(response);
        setAdvancedOrderEditor(response.advancedOrderEditor);
      },
    });
  }

  useEffect(() => {
    gerRestrictions();
  }, [])


  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (order_id:number) => {
    setPendingDeleteOrderId(order_id);
    setOpenDeletePasswordDialog(true);
  }



  const deleteItem = () => {
    if (!deleteMasterPassword) {
      enqueueSnackbar('Por favor ingrese la contraseña maestra', { variant: 'error' });
      return;
    }

    setLoading(true);

    const body = {
      order_id: pendingDeleteOrderId,
      master_password: deleteMasterPassword
    }

    ApiRequest({
      url: "/orders/deleteItem",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body,
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar('Pedido eliminado con éxito', { variant: 'success' });
          loadList();
          setOpenDeletePasswordDialog(false);
          setDeleteMasterPassword("");
          setShowDeletePassword(false);
          setPendingDeleteOrderId(null);
        } else {
          enqueueSnackbar(response.message || 'Error al eliminar el pedido', { variant: 'error' });
        }
        setLoading(false);
      },
      error: (err: any) => {
        console.log(err);
        enqueueSnackbar('Error al eliminar el pedido', { variant: 'error' });
        setLoading(false);
      }
    });
  }
  

  /*=========================================================
  VOID PAYMENT
  =========================================================*/
  const handleVoidOrder = (order_id: number) => {
    setActiveVoidItem(order_id);
    setOpenVoidAlert(true);
  };

  const voidOrder = () => {
    const body = {
      order_id: activeVoidItem,
    };

    ApiRequest({
      url: '/orders/voidOrder',
      method: 'post',
      headers: {
        ltkn: localStorage.getItem('ltkn'),
      },
      body,
      setResponse: (response: any) => {
        if (response.status === 'error') {
          enqueueSnackbar(response.message || 'Error al anular', { variant: 'error' });
        } else {
          enqueueSnackbar(response.message || 'Pedido anulado correctamente', { variant: 'success' });
          loadList();
        }
      },
    });
  };

  /*=========================================================
  EXPORT ORDER
  =========================================================*/
  const handleExportOrder = (order_id: number) => {
    setLoading(true);
    ApiRequest({
      url: "/orders/exportOrder",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        order_id: order_id,
      },
      setResponse: (response: any) => {
        console.log(response)
        if (response) {
            downloadFile(response);
          }
        setLoading(false);
      },
    });
  };

// call global snackbar
  
const [openAlert, setOpenAlert] = useState(false);
const [activeItem, setActiveItem] = useState<any>(null);

const [openVoidAlert, setOpenVoidAlert] = useState(false);
const [activeVoidItem, setActiveVoidItem] = useState<any>(null);

// Send invoice email state
const [openEmailDialog, setOpenEmailDialog] = useState(false);
const [emailOrderId, setEmailOrderId] = useState<number | null>(null);
const [emailDocType, setEmailDocType] = useState<'invoice' | 'credit_note'>('invoice');
const [emailList, setEmailList] = useState<string[]>([]);
const [emailInput, setEmailInput] = useState('');
const [sendingEmail, setSendingEmail] = useState(false);

const handleOpenEmailDialog = (orderId: number, clientEmail?: string, docType: 'invoice' | 'credit_note' = 'invoice') => {
  setEmailOrderId(orderId);
  setEmailDocType(docType);
  setEmailList(clientEmail ? [clientEmail] : []);
  setEmailInput('');
  setOpenEmailDialog(true);
};

const handleAddEmail = () => {
  const emails = emailInput.split(',').map(e => e.trim()).filter(e => e && /\S+@\S+\.\S+/.test(e));
  if (emails.length) {
    setEmailList(prev => [...prev, ...emails.filter(e => !prev.includes(e))]);
    setEmailInput('');
  }
};

const handleEmailKeyDown = (e: React.KeyboardEvent) => {
  if (e.key === 'Enter' || e.key === ',') {
    e.preventDefault();
    handleAddEmail();
  }
};

const handleSendInvoiceEmail = () => {
  if (!emailList.length || !emailOrderId) return;
  setSendingEmail(true);
  ApiRequest({
    url: emailDocType === 'credit_note' ? '/orders/sendCreditNoteEmail' : '/orders/sendInvoiceEmail',
    method: 'post',
    headers: { ltkn: localStorage.getItem('ltkn') },
    body: { order_id: emailOrderId, emails: emailList },
    setResponse: (response: any) => {
      setSendingEmail(false);
      if (response.status === 'success') {
        enqueueSnackbar(emailDocType === 'credit_note' ? 'Nota crédito enviada correctamente' : 'Factura enviada correctamente', { variant: 'success' });
        setOpenEmailDialog(false);
        loadList();
      } else {
        enqueueSnackbar(response.message || 'Error al enviar', { variant: 'error' });
      }
    },
  });
};

const filters = [
  { type: "text", label: "# Pedido", name: "company_order_id", value: "", overrides_mandatory: true },
  { type: "date_range", label: "Fecha", name: "date", value: "January 13, 2025 - January 13, 2025", mandatory: true },
  { type: "select", label: "Estado", name: "processed", value: "", options: [{label: "Todos", value: "all"}, {label: "Procesado", value: "1"}, {label: "No procesado", value: "0", default: true} ] },
  { type: "autocomplete", label: "Vendedor", name: "u.user_id", value: "", endpoint: "/users/listByRole", endpoint_params: { role_ids: [4,6,7] } },
  { type: "text", label: "Zona", name: "zone", value: "" },
  
  { type: "text", label: "Nombre cliente", name: "client_name", value: "" },
  { type: "text", label: "Nombre negocio", name: "business_name", value: "" },
  { type: "text", label: "NIT", name: "document", value: "" },
  
];

const setFilters = (tempFilters: any) => {
  setFiltersValues(tempFilters);
  localStorage.setItem('filters', JSON.stringify(tempFilters));
};

const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
const [downloadFiles, setDownloadFiles] = useState<{ordersFile: string, productsFile: string} | null>(null);
const [openDownloadPRNDialog, setOpenDownloadPRNDialog] = useState(false);
const [downloadPRNFiles, setDownloadPRNFiles] = useState<{pedidosFile: string, cerosFile: string} | null>(null);

const exportCSV = () => {
  setLoading(true);
  const body: any = {};
  if (!selectAll && selectedOrderIds.size > 0) {
    body.order_ids = Array.from(selectedOrderIds).join(',');
  } else if (selectAll && deselectedWhenAll.size > 0) {
    body.filters = filtersValues;
    body.deselected_order_ids = Array.from(deselectedWhenAll).join(',');
  } else {
    body.filters = filtersValues;
  }
  ApiRequest({
    url: "/orders/exportCSV",
    method: "post",
    headers: {
      ltkn: localStorage.getItem("ltkn"),
    },
    body,
    setResponse: (response: any) => {
      if (response.status === "success") {
        setDownloadFiles({
          ordersFile: response.ordersFile,
          productsFile: response.productsFile
        });
        setOpenDownloadDialog(true);
        loadList();
      }
      setLoading(false);
    }
  });
}

const exportPRN = () => {
  setLoading(true);
  const body: any = {};
  if (!selectAll && selectedOrderIds.size > 0) {
    body.order_ids = Array.from(selectedOrderIds).join(',');
  } else if (selectAll && deselectedWhenAll.size > 0) {
    body.filters = filtersValues;
    body.deselected_order_ids = Array.from(deselectedWhenAll).join(',');
  } else {
    body.filters = filtersValues;
  }
  ApiRequest({
    url: "/orders/exportPRN",
    method: "post",
    headers: {
      ltkn: localStorage.getItem("ltkn"),
    },
    body,
    setResponse: (response: any) => {
      if (response.status === "success") {
        setDownloadPRNFiles({
          pedidosFile: response.pedidosFile,
          cerosFile: response.cerosFile
        });
        setOpenDownloadPRNDialog(true);
        loadList();
      }
      setLoading(false);
    }
  });
}

const downloadFile = async (url: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const filename = url.split('/').pop() || 'download.txt';
    
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('Error downloading file:', error);
    enqueueSnackbar('Error al descargar el archivo', { variant: 'error' });
  }
};

const [openExportClients, setOpenExportClients] = useState(false);

  // Stock Validator Dialog state
  const [openStockValidator, setOpenStockValidator] = useState(false);
  const [stockValidatorProducts, setStockValidatorProducts] = useState<StockValidatorProduct[]>([]);
  const [stockValidatorOrderId, setStockValidatorOrderId] = useState<number | null>(null);
  const [stockValidatorInvoicing, setStockValidatorInvoicing] = useState(false);

  // Batch invoicing state
  const [batchOrderIds, setBatchOrderIds] = useState<number[]>([]);
  const [batchWarehouseId, setBatchWarehouseId] = useState('');
  const [batchAdjustedProducts, setBatchAdjustedProducts] = useState<StockValidatorProduct[]>([]);
  const [openBatchProgress, setOpenBatchProgress] = useState(false);
  const [openExcludedAlert, setOpenExcludedAlert] = useState(false);
  const [excludedAlertMessage, setExcludedAlertMessage] = useState('');
  const [pendingBatchData, setPendingBatchData] = useState<any>(null);

  // Batch detail dialog state
  const [openBatchDetail, setOpenBatchDetail] = useState(false);
  const [batchRefreshTrigger, setBatchRefreshTrigger] = useState(0);

  const handleOpenStockValidator = (orderId: number) => {
    // Fetch order details to get products
    ApiRequest({
      url: '/orders/details',
      method: 'get',
      headers: { ltkn: localStorage.getItem('ltkn') },
      query: { order_id: orderId },
      setResponse: (response: any) => {
        const data = response.data || {};
        let products: any[] = [];
        try {
          products = typeof data.products === 'string' ? JSON.parse(data.products) : (data.products || []);
        } catch { products = []; }

        const mapped: StockValidatorProduct[] = products.map((p: any) => {
          const info = p.product_info || {};
          const measureType = (info.product_measure_type || '').toLowerCase();
          let qty = 0;
          if (measureType === 'm2') {
            qty = Number(p.boxes || 0) * Number(info.product_conversion || 0);
          } else if (measureType === 'unidad') {
            qty = Number(p.units || 0);
          } else {
            qty = Number(p.units || p.quantity || 0);
          }
          return {
            product_id: info.product_id,
            product_name: info.product_name || '',
            product_code: info.product_code || '',
            quantity: qty || Number(p.quantity || 0),
          };
        }).filter((p: StockValidatorProduct) => p.product_id);

        setStockValidatorProducts(mapped);
        setStockValidatorOrderId(orderId);
        setOpenStockValidator(true);
      },
    });
  };

  const handleBatchInvoice = () => {
    const body: any = {};
    if (!selectAll && selectedOrderIds.size > 0) {
      body.order_ids = Array.from(selectedOrderIds);
    } else if (selectAll) {
      body.filters = filtersValues;
      if (deselectedWhenAll.size > 0) body.deselected_order_ids = Array.from(deselectedWhenAll);
    } else {
      return;
    }

    ApiRequest({
      url: '/orders/batch-products',
      method: 'post',
      headers: { ltkn: localStorage.getItem('ltkn') },
      body,
      setResponse: (r: any) => {
        if (r.status === 'success') {
          const excluded: string[] = r.excludedClientNames || [];
          if (excluded.length > 0) {
            const names = excluded.slice(0, 3).join(', ');
            const extra = excluded.length > 3 ? ` y ${excluded.length - 3} más` : '';
            setExcludedAlertMessage(`Los siguientes clientes fueron excluidos de la facturación por ser tipo orden de pedido: ${names}${extra}`);
            setPendingBatchData(r);
            setOpenExcludedAlert(true);
          } else {
            setStockValidatorProducts(r.products);
            setBatchOrderIds(r.orderIds);
            setStockValidatorOrderId(null);
            setOpenStockValidator(true);
          }
        }
      },
    });
  };

  const handleExcludedAlertConfirm = () => {
    if (pendingBatchData) {
      setStockValidatorProducts(pendingBatchData.products);
      setBatchOrderIds(pendingBatchData.orderIds);
      setStockValidatorOrderId(null);
      setOpenStockValidator(true);
      setPendingBatchData(null);
    }
  };

  const handleBatchStockValidatorConfirm = (warehouseId: string, adjustedProducts: StockValidatorProduct[]) => {
    setOpenStockValidator(false);
    setBatchWarehouseId(warehouseId);
    setBatchAdjustedProducts(adjustedProducts);
    setOpenBatchProgress(true);
  };

  const handleStockValidatorConfirm = (warehouseId: string, adjustedProducts: StockValidatorProduct[]) => {
    if (!stockValidatorOrderId) {
      // Batch mode
      handleBatchStockValidatorConfirm(warehouseId, adjustedProducts);
      return;
    }
    setStockValidatorInvoicing(true);

    // Register substitutions for ALL products (so the backend knows the warehouse for inventory subtraction)
    const autoSavePromises: Promise<void>[] = [];
    for (const orig of stockValidatorProducts) {
      // Find what products in adjustedProducts correspond to this original
      const adjustedForProduct = adjustedProducts.filter(a => a.product_id === orig.product_id);
      const otherProducts = adjustedProducts.filter(a => a.product_id !== orig.product_id && !stockValidatorProducts.find(sp => sp.product_id === a.product_id));
      
      // If substitutions were already saved manually (has other products as substitutes), skip
      const hasManualSubs = otherProducts.length > 0;
      if (hasManualSubs) continue;

      const adjustedQty = adjustedForProduct.reduce((s, a) => s + a.quantity, 0);
      if (adjustedQty > 0) {
        autoSavePromises.push(new Promise<void>((resolve) => {
          ApiRequest({
            url: '/orders/substitutions/save',
            method: 'post',
            headers: { ltkn: localStorage.getItem('ltkn') },
            body: {
              order_id: stockValidatorOrderId,
              original_product_id: orig.product_id,
              original_quantity: orig.quantity,
              warehouse_id: warehouseId,
              substitutions: [{ product_id: orig.product_id, quantity: adjustedQty }],
            },
            setResponse: () => resolve(),
          });
        }));
      }
    }

    Promise.all(autoSavePromises).then(() => {
      handleRetryDian(stockValidatorOrderId!);
    });
  };

  const handleRetryDian = (order_id: number) => {
    ApiRequest({
      url: '/dian/invoice/retry-order',
      method: 'post',
      headers: { ltkn: localStorage.getItem('ltkn') },
      body: { order_id },
      setResponse: (response: any) => {
        setStockValidatorInvoicing(false);
        setOpenStockValidator(false);
        if (response.status === 'already_accepted') {
          enqueueSnackbar('La factura ya fue aceptada por la DIAN', { variant: 'info' });
        } else if (response.success) {
          enqueueSnackbar('Factura enviada a la DIAN exitosamente', { variant: 'success' });
        } else {
          // Mostrar el motivo real del rechazo/error (reglas DIAN, p.ej. FAN04)
          const dianErrors = response.dianResponse?.errors;
          const reason = Array.isArray(dianErrors) && dianErrors.length
            ? dianErrors.join(' | ')
            : (response.error || 'Error al reintentar factura DIAN');
          enqueueSnackbar(reason, { variant: 'error', autoHideDuration: 12000, style: { whiteSpace: 'pre-line' } });
        }
        loadList();
      },
    });
  };

  // Master password for delete
  const [openDeletePasswordDialog, setOpenDeletePasswordDialog] = useState(false);
  const [deleteMasterPassword, setDeleteMasterPassword] = useState("");
  const [showDeletePassword, setShowDeletePassword] = useState(false);
  const [pendingDeleteOrderId, setPendingDeleteOrderId] = useState<number | null>(null);
  
  return (
      <div id='UsersList' className='ModuleContainer'>
        <div className="ModuleWrapper"> 
          <div className="boxContainerHeader">
            
            <div className="boxContainerTitle">
              <h2 className="h2_title">Pedidos</h2>
              <span className="h2_subtitle">Lista de pedidos creados</span>
            </div>
            
            <div className='module_tools'>
            
          </div>
          
            <div className="boxContainerActions">
              <Button
              variant="outlined"
              color="primary"
              startIcon={<TuneIcon />}
              onClick={() => setOpen(true)}
            >
              Filtrar
            </Button>

            <Button
              variant="contained"
              color="secondary"
              startIcon={<TbFileExport />}
              onClick={() => setOpenExportClients(true)}
            >
              Exportar Clientes
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null)
                setOpenEditor(true)
              }}
              startIcon={<AddIcon />}
            >
              Crear pedido
            </Button>

            </div>
            
          </div>


          

          <Filters2 open={open} setOpen={setOpen} filters={filters} setFilters={setFilters} />
          <FiltersApplied2 filtersValues={filtersValues} setFiltersValues={setFiltersValues} filters={filters} />

          <div id='UsersListIn'>

            {restrictions?.dian_enabled && (
              <BatchCard
                refreshTrigger={batchRefreshTrigger}
                onOpenDetail={() => setOpenBatchDetail(true)}
              />
            )}

            
              <Box id='WarehouseList' className='box100'>
              <TableContainer>
              <Table aria-label="sticky table"> 
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox" sx={{borderBottom:"none"}}>
                      <Checkbox
                        checked={isHeaderChecked}
                        indeterminate={isHeaderIndeterminate}
                        onChange={handleSelectAll}
                        size="small"
                      />
                    </TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>ID</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Cliente</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Zona</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Vendedor</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Tipo</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Valor</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Comentarios</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Fecha / HORA</TableCell>
                    <TableCell sx={{color:'#a8a8a8', borderBottom:"none"}}>Procesado</TableCell>
                    {restrictions?.dian_enabled && <TableCell sx={{color:'#a8a8a8', borderBottom:"none"}}>DIAN</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((item,i) => {

                      const date = moment(item.date).format('DD/MM/YYYY');
                      const time = moment(item.date).format('HH:mm');

                      return(
                      <TableRow 
                        
                        key={i}
                        hover
                        role="checkbox"
                        selected={isRowSelected(item.order_id)}
                      >        

                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isRowSelected(item.order_id)}
                          onChange={() => handleRowSelect(item.order_id)}
                          size="small"
                        />
                      </TableCell>

                      <TableCell>
                        {item.company_order_id}
                      </TableCell>

                        <TableCell>
                        <span className='flex_title'>{item.client_name + " " + item.client_last_name}</span>
                        <span className='flex_subtitle'>{item.business_name}</span><br/>
                        <span className='flex_subtitle' style={{fontSize:'11px', color:'#999'}}>{item.client_code}</span>
                        </TableCell>

                        <TableCell>
                          <span className='flex_title'>{item.zone_name}</span>
                          <span className='flex_subtitle'>{item.zone_code}</span>
                        </TableCell>

                        <TableCell>
                          {item.user_name}
                        </TableCell>  

                        <TableCell>
                          <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
                            <Chip
                              label={item.order_type_label}
                              size='small'
                              sx={{
                                backgroundColor:
                                  item.order_type === 'order'
                                    ? '#1976d2' // primary blue
                                    : item.order_type === 'quote'
                                      ? '#e7a42a' // orange
                                      : item.order_type === 'undelivered'
                                        ? '#cd3131' // red
                                        : undefined,
                                color: '#fff',
                              }}
                            />
                            {item.image_count > 0 && (
                              <PiCameraLight style={{color:'#1976d2', fontSize:'18px'}} title="Tiene imagen" />
                            )}
                          </div>
                        </TableCell>

                        <TableCell>
                          <span className='flex_title'>{item.total?.toLocaleString('es-CO', {minimumFractionDigits:0})}</span>
                        </TableCell>

                        <TableCell>
                          <span className='flex_subtitle' style={{maxWidth:'250px', display:'block', whiteSpace:'normal', wordBreak:'break-word'}}>{item.comments}</span>
                        </TableCell>

                        <TableCell>
                          <span className='flex_title'>{date}</span>
                          <span className='flex_subtitle'>{time}</span>
                        </TableCell>

                        <TableCell>
                          {item.order_type === 'order' && (
                            <Chip
                              label={item.processed}
                              size='small'
                              sx={{
                                backgroundColor: item.processed === 'Procesado' ? 'success.main' : 'grey.500',
                                color: '#fff',
                              }}
                            />
                          )}
                        </TableCell>

                        <TableCell>
                          {restrictions?.dian_enabled && item.order_type === 'order' && (
                            item.dian_status ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Tooltip
                                  arrow
                                  placement="top"
                                  title={
                                    (item.dian_status === 'rejected' || item.dian_status === 'error') && item.dian_validation_errors
                                      ? item.dian_validation_errors
                                      : ''
                                  }
                                >
                                  <Chip
                                    label={
                                      item.dian_status === 'accepted' ? 'Aceptada' :
                                      item.dian_status === 'rejected' ? 'Rechazada' :
                                      item.dian_status === 'error' ? 'Error' :
                                      item.dian_status === 'pending' || item.dian_status === 'sent' ? 'Enviada' :
                                      item.dian_status
                                    }
                                    size='small'
                                    sx={{
                                      backgroundColor:
                                        item.dian_status === 'accepted' ? '#4caf50' :
                                        item.dian_status === 'rejected' || item.dian_status === 'error' ? '#f44336' :
                                        '#ff9800',
                                      color: '#fff',
                                      cursor: (item.dian_status === 'rejected' || item.dian_status === 'error') && item.dian_validation_errors ? 'help' : 'default',
                                    }}
                                  />
                                </Tooltip>
                                {item.dian_email_status && (
                                  <Tooltip
                                    arrow
                                    placement="top"
                                    title={item.dian_email_status === 'sent' ? 'Correo enviado' : 'Error al enviar correo'}
                                  >
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                      <PiEnvelopeSimpleLight
                                        style={{
                                          fontSize: '18px',
                                          color: item.dian_email_status === 'sent' ? '#4caf50' : '#f44336',
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                )}
                              </div>
                            ) : (
                              <Chip label="No facturado" size='small' sx={{ backgroundColor: '#9e9e9e', color: '#fff' }} />
                            )
                          )}
                        </TableCell>

                        <TableCell align="right">
                          {item.is_voided === 1 && (
                            <Chip
                              label="Anulado"
                              color="error"
                              variant="outlined"
                              size="small"
                            />
                          )}

                          <IconButton onClick={(e) => handleMenuClick(e, item.order_id, item)} size="small">
                            <PiDotsThreeOutlineFill />
                          </IconButton>
                          
                        </TableCell>
                      </TableRow>
                    )})}
                </TableBody>
              </Table>
            </TableContainer>
            
            <Pagination count={total_pages} page={page}  onChange={(event, value) => {
              setPage(value);
              document.getElementById('main-content')?.scrollTo({ top: 0, behavior: 'smooth' });
            }
            } 
            color="primary"
            style={{"marginTop": "20px","alignSelf": "center"}}
            />
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {selectedItem && (
                <>
                  <MenuItem onClick={() => { handleOrderSummary(); setUndeliveredView(selectedItem.order_type === 'undelivered'); setActiveItem(selectedOrderId); setOpenEditor(true); handleMenuClose(); }}>
                    <PiPencilLight style={{ marginRight: 8 }} />
                    Detalle
                  </MenuItem>
                  {selectedItem.order_type !== 'undelivered' && (
                    <MenuItem onClick={() => { handleExportOrder(selectedOrderId!); handleMenuClose(); }}>
                      <TbFileExport style={{ marginRight: 8 }} />
                      Exportar
                    </MenuItem>
                  )}
                  {restrictions?.dian_enabled && selectedItem.order_type !== 'undelivered' && selectedItem.dian_status === 'accepted' && (
                    <MenuItem onClick={() => { handleOpenEmailDialog(selectedOrderId!, selectedItem.client_email, 'invoice'); handleMenuClose(); }}>
                      <PiEnvelopeSimpleLight style={{ marginRight: 8 }} />
                      Enviar factura
                    </MenuItem>
                  )}
                  {restrictions?.dian_enabled && selectedItem.order_type !== 'undelivered' && selectedItem.is_voided === 1 && selectedItem.dian_status === 'accepted' && (
                    <MenuItem onClick={() => { handleOpenEmailDialog(selectedOrderId!, selectedItem.client_email, 'credit_note'); handleMenuClose(); }}>
                      <PiEnvelopeSimpleLight style={{ marginRight: 8 }} />
                      Enviar nota crédito
                    </MenuItem>
                  )}
                  {selectedItem.order_type !== 'undelivered' && (
                    <MenuItem onClick={() => { handleDelete(selectedOrderId!); handleMenuClose(); }} sx={{ color: 'error.main' }}>
                      <PiXCircleLight style={{ marginRight: 8 }} />
                      Borrar
                    </MenuItem>
                  )}
                  {selectedItem.order_type !== 'undelivered' && selectedItem.is_voided !== 1 && (
                    <MenuItem onClick={() => { handleVoidOrder(selectedOrderId!); handleMenuClose(); }}>
                      <RiDeleteBin6Line style={{ marginRight: 8 }} />
                      Anular
                    </MenuItem>
                  )}
                  {restrictions?.dian_enabled && selectedItem.order_type !== 'undelivered' && selectedItem.dian_status && selectedItem.dian_status !== 'accepted' && (
                    <MenuItem onClick={() => { handleRetryDian(selectedOrderId!); handleMenuClose(); }}>
                      <TbFileExport style={{ marginRight: 8 }} />
                      Reintentar DIAN
                    </MenuItem>
                  )}
                  {restrictions?.dian_enabled && selectedItem.order_type !== 'undelivered' && !selectedItem.dian_status && selectedItem.is_voided !== 1 && selectedItem.invoice_type !== 1 && (
                    <MenuItem onClick={() => { handleOpenStockValidator(selectedOrderId!); handleMenuClose(); }}>
                      <TbFileExport style={{ marginRight: 8 }} />
                      Facturar
                    </MenuItem>
                  )}
                </>
              )}
            </Menu>
  
          </div>
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar este pedido? Esta acción no se puede deshacer."
            send={deleteItem}
        />

        <AlertDialog
          open={openVoidAlert}
          setOpen={setOpenVoidAlert}
          subtitle="¿Está seguro que desea anular este recaudo?"
          send={voidOrder}
        />

        <AlertDialog
          open={openExcludedAlert}
          setOpen={setOpenExcludedAlert}
          subtitle={excludedAlertMessage}
          send={handleExcludedAlertConfirm}
        />

        {/* Send Invoice Email Dialog */}
        <Dialog open={openEmailDialog} onClose={() => setOpenEmailDialog(false)} maxWidth="sm" fullWidth>
          <DialogTitle>{emailDocType === 'credit_note' ? 'Enviar nota crédito por correo' : 'Enviar factura por correo'}</DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 12, marginTop: 8 }}>
              {emailList.map((email, i) => (
                <Chip key={i} label={email} onDelete={() => setEmailList(prev => prev.filter((_, idx) => idx !== i))} size="small" />
              ))}
            </div>
            <TextField
              fullWidth
              size="small"
              label="Agregar correos (separados por coma o Enter)"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              onKeyDown={handleEmailKeyDown}
              onBlur={handleAddEmail}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenEmailDialog(false)}>Cancelar</Button>
            <Button variant="contained" onClick={handleSendInvoiceEmail} disabled={!emailList.length || sendingEmail}>
              {sendingEmail ? <CircularProgress size={20} /> : 'Enviar'}
            </Button>
          </DialogActions>
        </Dialog>



        <OrdersEditor
          setLoading={setLoading}
          openEditor={openEditor} 
          setOpenEditor={setOpenEditor}
          order_id={activeItem} 
          loadList={loadList}
          handleClose={() => setOpenEditor(false)}
          advancedOrderEditor={advancedOrderEditor}
          undeliveredView={undeliveredView}
        />

        {/* Master Password Dialog for Delete */}
        <Dialog
          open={openDeletePasswordDialog}
          onClose={() => {
            setOpenDeletePasswordDialog(false);
            setDeleteMasterPassword("");
            setShowDeletePassword(false);
            setPendingDeleteOrderId(null);
          }}
        >
          <div className="DialogContainer" style={{maxWidth:'450px'}}>
            <div className="ModuleWrapper">
              <div className="boxContainerHeader">
                <div className="boxContainerTitle">
                  <h2 className="h2_title">Confirmar eliminación</h2>
                  <span className="h2_subtitle">Para eliminar este pedido, ingrese la contraseña maestra</span>
                </div>
              </div>

              <TextField
                label="Contraseña maestra"
                type={showDeletePassword ? "text" : "password"}
                fullWidth
                value={deleteMasterPassword}
                onChange={(e) => setDeleteMasterPassword(e.target.value)}
                margin="normal"
                autoFocus
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => setShowDeletePassword(!showDeletePassword)}
                      edge="end"
                    >
                      {showDeletePassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
              />
            </div>
          </div>

          <div className="dialogButtons">
            <Button
              onClick={() => {
                setOpenDeletePasswordDialog(false);
                setDeleteMasterPassword("");
                setShowDeletePassword(false);
                setPendingDeleteOrderId(null);
              }}
              variant="outlined"
              className="button_2"
            >
              Cancelar
            </Button>

            <Button
              onClick={deleteItem}
              variant="contained"
              className="button_1"
              color="error"
            >
              Eliminar
            </Button>
          </div>
        </Dialog>

        <Dialog
          open={openDownloadDialog}
          onClose={() => setOpenDownloadDialog(false)}
          aria-labelledby="download-dialog-title"
        >
          <div style={{ padding: '20px' }}>
            <h2 id="download-dialog-title" style={{ marginBottom: '20px' }}>Descargar archivos exportados (CSV)</h2>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => downloadFiles?.ordersFile && downloadFile(downloadFiles.ordersFile)}
              >
                Descargar Pedidos
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => downloadFiles?.productsFile && downloadFile(downloadFiles.productsFile)}
              >
                Descargar Productos
              </Button>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={openDownloadPRNDialog}
          onClose={() => setOpenDownloadPRNDialog(false)}
          aria-labelledby="download-prn-dialog-title"
        >
          <div style={{ padding: '20px' }}>
            <h2 id="download-prn-dialog-title" style={{ marginBottom: '20px' }}>Descargar archivos exportados (PRN)</h2>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => downloadPRNFiles?.pedidosFile && downloadFile(downloadPRNFiles.pedidosFile)}
              >
                Descargar Pedidos (PRN)
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => downloadPRNFiles?.cerosFile && downloadFile(downloadPRNFiles.cerosFile)}
              >
                Descargar Ceros (PRN)
              </Button>
            </div>
          </div>
        </Dialog>

        <ExportClientsDialog 
          open={openExportClients}
          onClose={() => setOpenExportClients(false)}
        />

        <StockValidatorDialog
          open={openStockValidator}
          onClose={() => setOpenStockValidator(false)}
          products={stockValidatorProducts}
          orderIds={stockValidatorOrderId ? [stockValidatorOrderId] : batchOrderIds}
          invoicing={stockValidatorInvoicing}
          onConfirm={handleStockValidatorConfirm}
        />

        {selectedCount > 0 && (
          <div className="selection_toolbar">
            <span className="selection_toolbar__count">
              {selectedCount} de {totalItems} pedidos seleccionados
            </span>
            <div className="selection_toolbar__actions">
              {restrictions?.dian_enabled && (
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleBatchInvoice}
                >
                  Facturar
                </Button>
              )}
              <Button
                variant="outlined"
                size="small"
                startIcon={<TbFileExport />}
                onClick={exportCSV}
              >
                Exportar Pedidos
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={<TbFileExport />}
                onClick={exportPRN}
              >
                Exportar Pedidos (PRN)
              </Button>
              <Button
                variant="text"
                size="small"
                onClick={() => {
                  setSelectAll(false);
                  setSelectedOrderIds(new Set());
                  setDeselectedWhenAll(new Set());
                }}
              >
                Cancelar
              </Button>
            </div>
          </div>
        )}

        <BatchInvoiceProgressDialog
          open={openBatchProgress}
          onClose={() => setOpenBatchProgress(false)}
          orderIds={batchOrderIds}
          warehouseId={batchWarehouseId}
          adjustedProducts={batchAdjustedProducts}
          onDone={() => { loadList(); setSelectedOrderIds(new Set()); setSelectAll(false); setBatchRefreshTrigger(t => t + 1); }}
        />

        <BatchDetailDialog
          open={openBatchDetail}
          onClose={() => setOpenBatchDetail(false)}
          onRetryDone={() => { loadList(); setBatchRefreshTrigger(t => t + 1); }}
        />

    </div>
  );
};